import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DocumentShareState {
  isShared: boolean
  docId: string | null
  orgId: string | null
  shareId: string | null
}

const initialState: DocumentShareState = {
  isShared: false,
  docId: null,
  orgId: null,
  shareId: null,
}

export const documentShareSlice = createSlice({
  name: 'documentShare',
  initialState,
  reducers: {
    setDocumentShare: (state, action: PayloadAction<{
      docId: string
      orgId: string
      shareId?: string
    }>) => {
      state.isShared = true
      state.docId = action.payload.docId
      state.orgId = action.payload.orgId
      state.shareId = action.payload.shareId || null
    },
    clearDocumentShare: (state) => {
      state.isShared = false
      state.docId = null
      state.orgId = null
      state.shareId = null
    },
  },
})

export const { setDocumentShare, clearDocumentShare } = documentShareSlice.actions

export default documentShareSlice.reducer